import "./GarageDoorRepairHillsDistrict.module.css";
import Header from "@/reusable_sections/Header";
import GarageHero from "./sections/GarageHero";
import Minimaloverview from "./sections/Minimaloverview";
import GarageServices from "./sections/GarageServices";
import GaragePartners from "./sections/GaragePartners";
import GarageWorkflow from "./sections/GarageWorkflow";
import GarageBenefits from "./sections/GarageBenefits";
import Suburbs from "./sections/Suburbs";
import Testimonials from "./sections/Testimonials";
import GarageFaq from "./sections/GarageFaq";
import GarageCta from "./sections/GarageCta";
import CustomFooter from "./sections/CustomFooter";
export default function GarageDoorRepairHillsDistrictPage() {
  return <div>
      <Header />
      <GarageHero />
      <Minimaloverview />
      <GarageServices />
      <GaragePartners />
      <GarageWorkflow />
      <GarageBenefits />
      <Suburbs />
      <Testimonials />
      <GarageFaq />
      <GarageCta />
      <CustomFooter />
    </div>;
}